import { getRegions } from "../api/regions";
import {
  getSellers,
  getTransactions,
  getSellerTransactions,
  getCardTransactions,
  getSeller,
  getSellerTerminals,
  getSellerAddresses,
  sellerStatistics,
} from "../api/seller";
import { getTerminals } from "../api/terminals";
import {
  getAccount,
  getClickPayments,
  getBozorPayPayments,
  getDevices,
  getPaymentComissions,
  getRevenue,
  getStatsPaymentServices,
  getStatsTransactions,
} from "../api/user";
import { getUsers } from "../api/users";
import { getBazaars } from "../api/bazaars";
import { getCategories } from "../api/categories";
import { getProducts, getProductById, getSellerProducts } from "../api/products";

export function getUsersQuery(params) {
  return {
    queryKey: ["users", params],
    queryFn: async () => getUsers(params),
  };
}

export function getProductByIdQuery(id) {
  return {
    queryKey: ["product", id],
    queryFn: async () => getProductById(id),
    enabled: !!id,
  };
}

export function getComissionsQuery(params) {
  return {
    queryKey: ["comissions", params],
    queryFn: async () => getPaymentComissions(params),
  };
}

export function getTerminslsQuery(params) {
  return {
    queryKey: ["terminals", params],
    queryFn: async () => getTerminals(params),
  };
}

export function getSellerStatsQuery(sellerId) {
  return {
    queryKey: ["seller-stats", sellerId],
    queryFn: async () => sellerStatistics(sellerId),
  };
}

export function getSellersQuery(params) {
  return {
    queryKey: ["sellers", params],
    queryFn: async () => getSellers(params),
  };
}

export function getSellerAddressesQuery(id) {
  return {
    queryKey: ["seller-addresses", id],
    queryFn: async () => getSellerAddresses(id),
  };
}

export function getSellerQuery(id) {
  return {
    queryKey: ["seller", id],
    queryFn: async () => getSeller(id),
  };
}

export function getSellerTerminalsQuery(id) {
  return {
    queryKey: ["seller-terminals", id],
    queryFn: async () => getSellerTerminals(id),
  };
}

export function getAccountQuery() {
  return {
    queryKey: ["account"],
    queryFn: async () => getAccount(),
  };
}

export function getDevicesQuery() {
  return {
    queryKey: ["devices"],
    queryFn: async () => getDevices(),
  };
}

export function getTransactionsQuery(params) {
  return {
    queryKey: ["transactions", params],
    queryFn: async () => getTransactions(params),
  };
}

export function getRegionsQuery(params) {
  return {
    queryKey: ["regions", params],
    queryFn: async () => getRegions(params),
  };
}

export function getSellerTransactionsQuery(params) {
  return {
    queryKey: ["seller-transactions", params],
    queryFn: async () => getSellerTransactions(params),
  };
}

export function getCardTransactionsQuery(params) {
  return {
    queryKey: ["card-transactions", params],
    queryFn: async () => getCardTransactions(params),
  };
}

export function getStatsTransactionsQuery(params) {
  return {
    queryKey: ["stats-transactions", params],
    queryFn: async () => getStatsTransactions(params),
  };
}

export function getStatsPaymentServicesQuery(params) {
  return {
    queryKey: ["click-payments", params],
    queryFn: async () => getStatsPaymentServices(params),
  };
}

export function getRevenueQuery(params) {
  return {
    queryKey: ["revenue", params],
    queryFn: async () => getRevenue(params),
  };
}

export function getClickPaymentsQuery(sellerId) {
  return {
    queryKey: ["stats-payment-services", sellerId],
    queryFn: async () => getClickPayments(sellerId),
  };
}

export function getBozorPayPaymentsQuery(sellerId) {
  return {
    queryKey: ["bozor-pay-payments", sellerId],
    queryFn: async () => getBozorPayPayments(sellerId),
  };
}

export function getBazaarsQuery(params) {
  return {
    queryKey: ["bazaars", params],
    queryFn: async () => getBazaars(params),
  };
}

export function getCategoriesQuery(params) {
  return {
    queryKey: ["categories", params],
    queryFn: async () => getCategories(params),
  };
}

export function getProductsQuery(params) {
  return {
    queryKey: ["products", params],
    queryFn: async () => getProducts(params),
  };
}

export function getSellerProductsQuery(sellerId, params) {
  return {
    queryKey: ["seller-products", sellerId, params],
    queryFn: async () => getSellerProducts(sellerId, params),
    enabled: !!sellerId,
  };
}

